import React from "react";

// The error beside an auto-saving profile field. A save in flight or a good
// save shows nothing (founder, 1.5.2: "just have it save automatically, like
// all modern apps") — only a FAILED save speaks, so the reason is still said.
// Split out of pages/ProfilePage.tsx; every profile sheet renders it.

// Per-field save state for the auto-save profile form. Replaces the old single
// "Update profile" button — each field now saves and reports on its own.
export type SaveState = { state: "saving" | "error"; msg?: string };

export const FieldStatus: React.FC<{ status?: SaveState }> = ({ status }) => {
  if (!status || status.state !== "error") return null;
  return <span className="field-status field-status--error">{status.msg}</span>;
};
